import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGlass: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGlass"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 6C8.68629 6 6 8.68629 6 12C6 12.4097 6.04131 12.811 6.12012 13.1992L8.08008 12.8008C8.02774 12.5429 8 12.2752 8 12C8 9.79086 9.79086 8 12 8C12.2752 8 12.5429 8.02774 12.8008 8.08008L13.1992 6.12012C12.811 6.04131 12.4097 6 12 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGlass;
